import { Card, Avatar, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import type { Mentor } from "../../models/Mentor";

const { Title, Text } = Typography;

interface MentorCardProps {
    mentor: Mentor;
}

const MentorCard = ({ mentor }: MentorCardProps) => {
    const formattedPrice = Number(mentor.price).toFixed(2);

    return (
        <Link to={`/mentorship/session/new/${mentor.user.username}`}>
            <Card
                hoverable
                className="h-full flex flex-col"
                cover={
                    <div className="flex h-48 items-center justify-center bg-gray-100">
                        <div className="flex justify-center w-full">
                            <Avatar 
                                size={128}
                                style={{ marginTop: '10%' }}
                                src={mentor.user.profile_pic_url}
                                icon={<UserOutlined />}
                            />
                        </div>
                    </div>
                }
            >
                <Card.Meta
                    title={`${mentor.user.first_name} ${mentor.user.last_name}` || mentor.user.username}
                    description={
                        <div className="space-y-2 flex-grow">
                            <Text className="line-clamp-3">{mentor.description}</Text>
                            {mentor.mentorship_topics && (
                                <div className="mt-2">
                                    <Text strong>Topics: </Text>
                                    <Text className="line-clamp-2">{mentor.mentorship_topics}</Text>
                                </div>
                            )}
                            <div>
                                <Text strong>Price: </Text>
                                <Text>${formattedPrice}</Text>
                            </div>
                        </div>
                    }
                />
            </Card>
        </Link>
    );
};

export default MentorCard; 